export enum ILoadState {
  'NEW',
  'LOADING',
  'READY',
  'NOTFOUND',
  'ERROR',
}
